import { LimitOrderQuotesSections } from 'components/Workspaces/SecondaryMarketQuotes/Tabs/limitOrder/sections.connect';

export type LimitOrderFormContentProps = { tabId: string };
export function LimitOrderFormContent({ tabId }: LimitOrderFormContentProps) {
  return (
    <>
      <LimitOrderQuotesSections.ConnectedProductSummary tabId={tabId} />
      <LimitOrderQuotesSections.ConnectedTradeInformation tabId={tabId} isModification={false} />
      <LimitOrderQuotesSections.ConnectedLimit formId={tabId} workspace="secondaryMarketQuotes" />
      <LimitOrderQuotesSections.ConnectedBookingInformation tabId={tabId} />
    </>
  );
}
